import {Box} from "@mui/system";
import MsgDataSource from "../Utilities/MsgDataSources/MsgDataSource";
import styles from "../organizationMainStyles";
import {getAccessibilityMode, getLabel} from "../Utilities/organizationSettingsUtils";
import {fragmentId} from "../Utilities/organizationSettingsConstants";
import _ from "lodash";
import NoDataView from "../EmptyStates/NoDataView";
import React from "react";
import MsgDataSourcesEmptyState from "../EmptyStates/MsgDataSourcesEmptyState";
import useGetMsgDataSources from "../hooks/useGetMsgDataSources";
import useGetTrendsMsgDataSources from "../hooks/useGetTrendsMsgDataSources";

export default function MsgDataSources({organizationId, organizationTrendsId}) {
    const label = getLabel(fragmentId.MSG_DATA_SOURCES);
    let {msgSources, loading: loadingTeams} = useGetMsgDataSources(organizationId);
    const {trendsMsgDataSources, loading: loadingTrends} = useGetTrendsMsgDataSources(organizationTrendsId);
    const mode = getAccessibilityMode();
    msgSources = _.sortBy(msgSources, (item) => _.toString(item?.name).toLowerCase());

    const loading = loadingTeams || (organizationTrendsId && loadingTrends);

    if(_.isEmpty(organizationId) && _.isEmpty(msgSources)) {
        return <NoDataView />
    }

    if(loading) {
        return (
            <Box sx={styles.sectionWrapper}>
                <MsgDataSourcesEmptyState/>
            </Box>
        )
    }

    if(!loading && _.isEmpty(msgSources)) {
        return <NoDataView description={'No data found'} />
    }

    const trendsMsgDataSourcesById = _.keyBy(trendsMsgDataSources, 'id');

    return (
        <Box sx={styles.sectionWrapper}>
            {
                msgSources && msgSources?.map((msgSource) =>
                    <MsgDataSource
                        key={msgSource.id}
                        msgSource={msgSource}
                        trendsMsgDataSourcesById={trendsMsgDataSourcesById}
                        mode={mode}
                        label={label}
                    />
                )
            }
        </Box>
    )
}
